var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4231 4.58337L13.4445 4.60383L8.04719 9.9305H18.3334V12.0696H8.04597L13.4445 17.3963L13.4231 17.4167H10.1726L3.66675 11.0006L10.1732 4.58398L13.4231 4.58337Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3784 5.08394L12.2466 5.08359L7.69598 9.57462L6.82875 10.4305H8.04719H17.8334V11.5696H8.04597H6.82733L7.69479 12.4255L12.2466 16.9167H10.3777L4.37882 11.0006L10.3784 5.08394Z",
    stroke: "#F5F5F5",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.b0c5831a3e085f9bc1f3a4d4258db260.svg";
export { ForwardRef as ReactComponent };